const strings: any = {
  ru: {
    pcUnsupported: 'Зайдите с мобильного устройства!',
    menu: 'Меню',
    logo: 'Q&A',
    categories: 'Категории',
    login: 'Войти',
    reg: 'Регистрация',
    email: 'Email',
    userName: 'Имя пользователя',
    password: 'Пароль',
    voteUp: 'Полезно',
    voteDown: 'Бесполезно',
    votes: 'Рейтинг',
    addComment: 'Добавить комментарий',
    addPost: 'Добавить пост',
    title: 'Заголовок',
    message: 'Сообщение',
    category: 'Категория',
    comment: 'Комментарий',
    submit: 'Отправить',
    loadMore: 'Загрузить ещё',
  },
  en: {
    pcUnsupported: 'Enter from mobile phone!',
    menu: 'Menu',
    logo: 'Q&A',
    categories: 'Categories',
    login: 'Log in',
    reg: 'Registration',
    email: 'Email',
    userName: 'Username',
    password: 'Password',
    voteUp: 'Usefull',
    voteDown: 'Useless',
    votes: 'Votes',
    addComment: 'Add comment',
    addPost: 'Add post',
    title: 'Title',
    message: 'Message',
    category: 'Category',
    comment: 'Comment',
    submit: 'Submit',
    loadMore: 'Load more',
  },
}

export function localization(string: string = 'undefined', language: string = 'en') {
  return strings[language][string];
}